import Image from 'next/image';
import { cn } from '@/app/utils/cn';
import { getDotcmsImageURL } from '@/app/utils/getDotcmsImageURL';
import LinkNoPrefetch from '@/components/link-noprefetch';
import { toSlug } from '@/app/authors/utils';

function Author({ author, priority = true, className, isDark = false }) {
    if (!author || (!author.firstName && !author.name) || !author.identifier) return null;

    const slug = author.computedSlug ?? toSlug(author.firstName, author.lastName);
    const resolvedImgSrc = getDotcmsImageURL({ src: author.identifier });

    return (
        <LinkNoPrefetch
            href={`/authors/${slug}`}
            className={cn('relative mt-auto flex h-12 flex-row gap-3', className)}>
            <div className="relative size-12 overflow-hidden rounded-full">
                <Image
                    priority={!!priority}
                    src={resolvedImgSrc || '/assets/icons/blog/dot.svg'}
                    alt={author.name || author.firstName || 'Author image'}
                    className="rounded-full object-cover"
                    quality={80}
                    fill
                    sizes="48px"
                />
            </div>

            <div className="flex flex-col justify-center">
                <p className={cn('text-sm', isDark ? 'text-white' : 'text-blue-700')}>
                    {author.firstName} {author.lastName}
                </p>
                <p className={cn('text-sm', isDark ? 'text-custom-transparent' : 'text-blue-600')}>
                    {author.title || author.contentletsTitle}
                </p>
            </div>
        </LinkNoPrefetch>
    );
}

export default Author;
